import React from "react";
import { useTheme } from "../context/ThemeContext";

const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString());

const hasValue = (value) => value !== null && value !== undefined;

function Delta({ pct, isLoss = false }) {
  if (pct == null) return null;

  const up = Number(pct) >= 0;

  const deltaColor = isLoss
    ? up
      ? "#ff7b7b"
      : "#22c55e"
    : up
      ? "#22c55e"
      : "#ff7b7b";

  return (
    <div
      className="text-sm mt-2 flex items-center gap-1"
      style={{ color: deltaColor }}
    >
      <span>{up ? "▲" : "▼"}</span>
      <span>{Math.abs(Number(pct)).toFixed(1)}%</span>
    </div>
  );
}

function Card({ label, value, unit, delta, dateLabel, isLoss = false }) {
  const { colors } = useTheme();

  return (
    <div
      className="rounded-xl p-4 min-h-[100px] border"
      style={{
        backgroundColor: colors.cardBg,
        borderColor: colors.border,
      }}
    >
      <div
        className="text-[10px] uppercase tracking-wider mb-1"
        style={{ color: colors.textSecondary }}
      >
        {label}
      </div>

      <div className="flex items-end gap-1">
        <div
          className="text-[22px] xl:text-[24px] font-bold leading-none"
          style={{
            color: isLoss ? "#ffb14a" : colors.primary,
          }}
        >
          {fmt(value)}
        </div>

        <div className="text-sm mb-1" style={{ color: colors.textSecondary }}>
          {unit}
        </div>
      </div>

      {delta != null && <Delta pct={delta} isLoss={isLoss} />}

      {dateLabel && (
        <div className="text-sm mt-2" style={{ color: colors.textSecondary }}>
          {dateLabel}
        </div>
      )}
    </div>
  );
}

export default function KPIStrip({ mode = "district", data = {} }) {
  const cards =
    mode === "filtered"
      ? [
          {
            key: "totalFlow",
            label: "Total Flow",
            value: data.totalFlow?.value,
            unit: "gal",
            delta: data.totalFlow?.deltaPct,
          },
          {
            key: "avgDaily",
            label: "Avg Daily",
            value: data.avgDaily?.value,
            unit: "gal/d",
            delta: data.avgDaily?.deltaPct,
          },
          {
            key: "peak",
            label: "Peak Day",
            value: data.peak?.value,
            unit: "gal",
            delta: data.peak?.deltaPct,
            dateLabel: data.peak?.dateLabel,
          },
        ]
      : [
          {
            key: "supply",
            label: "Supply",
            value: data.supply?.value,
            unit: "gal",
            delta: data.supply?.deltaPct,
          },
          {
            key: "demand",
            label: "Demand",
            value: data.demand?.value,
            unit: "gal",
            delta: data.demand?.deltaPct,
          },
          {
            key: "loss",
            label: "Loss",
            value: data.loss?.value,
            unit: "gal",
            delta: data.loss?.deltaPct,
            isLoss: true,
          },
          {
            key: "avgDaily",
            label: "Avg Daily",
            value: data.avgDaily?.value,
            unit: "gal/d",
            delta: data.avgDaily?.deltaPct,
          },
          {
            key: "peak",
            label: "Peak Day",
            value: data.peak?.value,
            unit: "gal",
            // delta: data.peak?.deltaPct,
            dateLabel: data.peak?.dateLabel,
          },
        ];

 const visibleCards = cards.filter((card) => hasValue(card.value));

const gridClass =
  visibleCards.length === 1
    ? "grid-cols-1"
    : visibleCards.length === 2
      ? "grid-cols-1 md:grid-cols-2"
      : visibleCards.length === 3
        ? "grid-cols-1 md:grid-cols-3"
        : visibleCards.length === 4
          ? "grid-cols-1 md:grid-cols-2 xl:grid-cols-4"
          : "grid-cols-1 md:grid-cols-2 xl:grid-cols-5";

return (
  <div className={`grid ${gridClass} gap-4 mt-4`}>
    {visibleCards.map((card) => (
      <Card
        key={card.key}
        label={card.label}
        value={card.value}
        unit={card.unit}
        delta={card.delta}
        dateLabel={card.dateLabel}
        isLoss={card.isLoss}
      />
    ))}
  </div>
);
}